import React from 'react';
import styled from 'styled-components';

import { CommonTheme } from 'app/shared/theme';
import {
  WithChildSVGProps,
  withChildSVGStyleCSS,
  withDimensionsCSS,
  withSpacingCSS,
  WithSpacingProps,
} from 'app/shared/components/styleUtils';
import { ReactComponent as MonogramLogo } from 'icons/sofar-logos/monogram.svg';
import { ReactComponent as MonogramLogoFilled } from 'icons/sofar-logos/monogram-filled.svg';
import { ReactComponent as PrimaryLogo } from 'icons/sofar-logos/primary.svg';

export interface LogoProps
  extends React.ComponentPropsWithRef<any>,
    WithSpacingProps {
  variant: 'primary' | 'monogram' | 'monogramFilled';
  fillColor: string;
  h: string;
}

interface LogoWrapperCSSProps extends WithChildSVGProps, WithSpacingProps {
  theme: CommonTheme;
  h: string;
  aspectRatio: string;
}

const LogoWrapper = styled.span<LogoWrapperCSSProps>`
  > svg {
    overflow: visible;
  }
  display: flex;
  ${withChildSVGStyleCSS};
  ${withSpacingCSS};
  ${withDimensionsCSS};
`;

export const Logo: React.FC<React.PropsWithChildren<LogoProps>> = ({
  variant,
  fillColor,
  ...props
}) => {
  const icon: React.FC<React.PropsWithChildren<React.SVGProps<SVGSVGElement>>> =
    variant === 'primary'
      ? PrimaryLogo
      : variant === 'monogram'
        ? MonogramLogo
        : MonogramLogoFilled;

  const aspectRatio = variant === 'primary' ? '2.125' : '1';

  return (
    <LogoWrapper
      svgFillColor={fillColor}
      svgStrokeColor="none !important"
      aspectRatio={aspectRatio}
      {...props}
    >
      {React.createElement(icon || 'span', { height: '100%', width: '100%' })}
    </LogoWrapper>
  );
};
